/*eslint no-sequences: "off"*/
/*eslint no-empty-pattern: "off"*/

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAlertContext } from './interfaces';
import { initState } from './init.state';

interface ValuePayload {
  type?: string;
  [key: string]: any;
}

interface AlertPayload {
  value: ValuePayload;
  [key: string]: any;
}

export const AlertContextSlice = createSlice({
  name: 'alertContext',
  initialState: initState,
  reducers: {
    SetAlert: (state: IAlertContext, action: PayloadAction<AlertPayload>) => {

      // Handle nested payload structure
      let typeValue = '';
      let valueProps = {};
      
      // Extract value properties if they exist
      if (action.payload.value) {
        valueProps = action.payload.value;
      }
      
      // Direct type property
      if (action.payload.type) {
        typeValue = action.payload.type;
      }
      // Check payload.value.type
      else if (action.payload.value && action.payload.value.type) {
        typeValue = action.payload.value.type;
      }
      // Check payload.payload.value.type (deeper nesting)
      else if (action.payload.payload && action.payload.payload.value && action.payload.payload.value.type) {
        typeValue = action.payload.payload.value.type;
      }
      
      
      const returnState = {
        ...state,
        alert: {
          ...initState.alert,
          ...valueProps,     // Spread the value properties
          type: typeValue,   // Explicitly set the type
          visible: true,
          show: true,
        },
      };

      return returnState;
    },

    ResetAlert: (state: IAlertContext) => {
      return initState;
    },

    HideAlert: (state: IAlertContext) => {
      return {
        alert: {
          ...initState.alert,
          visible: true,
          show: false,
        },
      };
    },

    SetInput: (state: IAlertContext, action: PayloadAction<{ value: any }>) => {
      return {
        ...state,
        alert: {
          ...state.alert,
          input: {
            ...(state.alert as any).input,
            value: action.payload.value,
          },
        },
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const { SetAlert, ResetAlert, HideAlert, SetInput } =
  AlertContextSlice.actions;

export default AlertContextSlice.reducer;
